
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/departures",
      function () {
        return require("private-next-pages/departures.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/departures"])
      });
    }
  